(function () {
    'use strict';

    angular
        .module('dialog-manager')
        .factory('action-dm-dialog-set-options', actionDialogSetOptions);

    function actionDialogSetOptions(DialogManager, lodash, $q) {
        return function (options, eventData, actionData) {
            return $q.when(run());

            function run() {
                DialogManager.setOption(options.dialogId, options.key, options.value);
                return true;
            }
        };
    }
})();
